import { useEffect } from "react";
import { Link } from "react-router-dom";
import LastWinnerItem from "../../../components/lastWinnerItem";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getRaffleList, resetRaffle } from "../../../store/raffle";

export default function WinnerList({ }) {
  const dispatch = useAppDispatch()
  const { raffleList } = useAppSelector((state) => state.raffle)
  const { skills } = useAppSelector((store) => store.user);

  useEffect(() => {
    dispatch(getRaffleList())
    dispatch(resetRaffle())
  }, [])

  useEffect(() => {
    console.log(raffleList)
  }, [raffleList])

  return (<>
    <div className="c-winner c-winner-list">
      {
        (skills.includes("admin.raffle.raffle") || skills.includes("super.admin")) &&
        <div className="buttons">
          <Link to='/mypurls/winner/getawinner'>
            <button className="buttonwinner buttonOrangeWinner">New Raffle</button>
          </Link>
        </div>
      }
      <div className="c-winner-list-container">
        <h1>Raffles List</h1>
        <div className="c-winner-list-contain">
          {
            raffleList.map((raffle: any, index: any) => <LastWinnerItem raffle={raffle} />)
          }
        </div>
      </div>
    </div>
  </>)
}